export const asyncCooldown = <T extends (...args: any[]) => Promise<any>>(
  func: T,
  limit: number,
): ((...args: Parameters<T>) => Promise<ReturnType<T> | undefined>) => {
  let blocked = false;

  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    if (blocked) {
      return Promise.resolve(undefined);
    }

    blocked = true;
    setTimeout(() => {
      blocked = false;
    }, limit);

    return func.apply(this, args) as ReturnType<T>;
  };
};
